import axios from 'axios'

import { handleMalwareScanBlocked } from './malwareScanResponseHandler'

const axiosPublicClient = axios.create({
    baseURL: '/v2/api',
})

// Surface the malware-scan download gate's 409 as a friendly "still scanning" toast, uniformly.
axiosPublicClient.interceptors.response.use((response) => response, handleMalwareScanBlocked)

export default axiosPublicClient
